import styled, { css } from 'styled-components';

import { Alignment } from '.';

const tooltipTextModifiers = {
  bottom: ({
    top,
    left,
    width,
    height,
    translateX = 0,
    offsetY,
    contentWidth = 0,
  }: any) => css`
    top: ${top - offsetY + height}px;
    left: ${left - translateX * (contentWidth - 40) - 20 + width / 2}px;
    &::after {
      position: absolute;
      top: ${offsetY}px;
      left: ${translateX * (contentWidth - 40) + 10}px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #ffffff;
    }
  `,
  left: ({ top, left, offsetX, offsetY }: any) => css`
    top: ${top + offsetY}px;
    left: ${left - offsetX}px;
    transform: translateX(-100%);
    &::after {
      top: 10px;
      right: -9px;
      border-top: solid 10px transparent;
      border-left: solid 10px #ffffff;
      border-bottom: solid 10px transparent;
    }
  `,
  right: () => css``,
  top: () => css``,
};

type TooltipTextProps = {
  alignment: Alignment;
  visiblility?: boolean;
  top: number;
  left: number;
  width: number;
  height: number;
  transition?: number;
  translateX?: number;
  contentWidth?: number;
};

export const TooltipContent = styled.div<TooltipTextProps>`
  ${({
    alignment,
    visiblility,
    top,
    left,
    width,
    height,
    transition = 0,
    translateX,
    contentWidth,
  }) => css`
    position: fixed;
    display: ${visiblility ? 'block' : 'none'};
    background: #ffffff;
    padding: 16px;
    border-radius: 8px;
    z-index: 998;
    transition: top ${transition}ms;
    box-shadow: 0 0 10px 2px #0000003b;
    &::after {
      content: '';
      position: fixed;
    }
    ${tooltipTextModifiers[alignment]({
      top,
      left,
      width,
      height,
      offsetX: 10,
      offsetY: -10,
      translateX,
      contentWidth,
    })};
  `}
`;

export const TooltipFrameContent = styled.div`
  ${() => css`
    padding: 16px;
  `}
`;
